export const categoriesList = [
    "DEI",
    "Org Chart",
    "People Analytics",
    "Headcount Planning",
    "Employee Experience",
    "Best Practices",
    "Product Updates",
    "Company Updates",
    "Performance Management",
]
